import { Action } from 'redux';

import ExplorerData from '../interfaces/ExplorerData';
import ActionFetchUserExplorerCurrentEvent from '../interfaces/actions/ActionFetchUserExplorerCurrentEvent';
import ActionFetchUserExplorerChangeCategory from '../interfaces/actions/ActionFetchUserExplorerChangeCategory';
import ActionFetchUserExplorerSuccess from '../interfaces/actions/ActionFetchUserExplorerSuccess';

import * as Const from '../constants';

export const fetchUserExplorerInitAction = (): Action => {
  return {
    type: Const.FETCH_USER_EXPLORER_INIT,
  };
};

export const fetchUserExplorerPendingAction = (): Action => {
  return {
    type: Const.FETCH_USER_EXPLORER_PENDING,
  };
};

export const fetchUserExplorerErrorAction = (): Action => {
  return {
    type: Const.FETCH_USER_EXPLORER_ERROR,

  };
};

export const fetchUserExplorerSuccessAction = (payload: ExplorerData): ActionFetchUserExplorerSuccess => {
  return {
    type: Const.FETCH_USER_EXPLORER_SUCCESS,
    payload,
  };
};
export const fetchUserExplorerCurrentEventAction = (category: string, label: string)
  : ActionFetchUserExplorerCurrentEvent => {
  return {
    type: Const.FETCH_USER_EXPLORER_CURRENT_EVENT,
    category,
    label,
  };
};

export const fetchUserExplorerChangeCategoryAction = (category: string, checked: boolean)
  : ActionFetchUserExplorerChangeCategory => {
  return {
    type: Const.FETCH_USER_EXPLORER_CHANGE_CATEGORY,
    category,
    checked,
  };
};
